<div *ngIf="duelSeries">
  <div (click)="onClickModalShutter()" class="crossButtonStyle">
    <span class="crossButtonHover"></span>
    <span class="crossButtonHover"></span>
  </div>
  <div *ngIf="!getDuelPlayerDetailsOpened()">
    <div *ngIf="hideAdminPanelForNoOnePlayer()">
      <div class="row p-1 div-cenered mt-15 mb-3 mb-lg-0" style="margin-top: 30px">
        <h2>
          Встреча #{{ duelSeries.number }}
          {{ duelSeries.group ? "в группе " + duelSeries.group.number : "" }}
        </h2>
        <p class="fs12" *ngIf="duelSeries.scheduled_at">
          {{ duelSeries.scheduled_at | amDateFormat: "DD.MM.YYYY HH:mm" }}
          <span *ngIf="duelSeries.table_number"><br />стол {{ duelSeries.table_number }}</span>
        </p>
      </div>
      <div [ngClass]="{
    'row justify-content-center mt--15 pb-5 playersInfoRow': !adminPanelIsAvailable(),
    'playersInfoHider': adminPanelIsAvailable()
    }">
        <div class="col-6 col-lg-4 order-1 order-lg-0">
          <div class="d-flex div-cenered playerSectionWrapper">
            <app-player-card-small [player]="duelSeries.player_one" class="playerInnerWrapper"
              [openDuelPlayerDetails]="playerNameLinkClickHandler.bind(this)"></app-player-card-small>
            <app-player-replacer *ngIf="
            !duelSeries.group && is_staff && getIsPC()
            && duelSeries?.player_one && duelSeries?.player_two
            && duelCanBeReplayed()" [currentDuelId]="duelSeries?.number" [currentPlayerId]="duelSeries?.player_one?.id"
              [tournamentId]="this.duelSeries.tournament_id">
            </app-player-replacer>
          </div>
        </div>
        <div class="col-10 col-lg-4 order-3 order-lg-1 mt-4 resultsPositionSetter" *ngIf="getIsPC()">
          <div class="tableDiv">
            <table class="table"
              *ngIf="(duelSeries.previewDuels && duelSeries.previewDuels.length) || (duelSeries.duels && duelSeries.duels.length > 0) || is_staff">
              <thead class="tHead">
                <tr>
                  <th colspan="3" class="align-center tHeadCellPaddingsCleaner" scope="col">
                    <div class="tHeadDiv">
                      Результаты партий
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody
                *ngIf="((duelSeries.previewDuels && duelSeries.previewDuels.length) || (duelSeries.duels && duelSeries.duels.length)) && !adminPanelIsAvailable()"
                class="tBody">
                <tr
                  *ngFor="let duel of duelSeries.previewDuels && duelSeries.previewDuels.length ? duelSeries.previewDuels : duelSeries.duels">
                  <td>
                    <div class="d-flex justify-content-center">
                      <a href="javascript:void(0)" (click)="decrementDuelScore(duel, 1)"
                        *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-left"></i></a>
                      <div [class.cell-bordered-prim_color]="duel.player_one_score > duel.player_two_score"
                        [class.cell-bordered]="duel.player_one_score <= duel.player_two_score">{{ duel.player_one_score
                        }}</div>
                      <a href="javascript:void(0)" (click)="incrementDuelScore(duel, 1)"
                        *ngIf="duel.id && controlsAvailable()" class="pt-1"><i
                          class="fa-solid fa-chevron-right"></i></a>
                    </div>
                  </td>
                  <td>
                    <div class="cell">Партия {{ duel.number }}</div>
                    <div class="cell"><a href="javascript: void(0)" class="text-danger" (click)="deleteDuel(duel.id)"
                        *ngIf="duel.id && controlsAvailable()">Удалить</a></div>
                  </td>
                  <td>
                    <div class="d-flex justify-content-center">
                      <a href="javascript:void(0)" (click)="decrementDuelScore(duel, 2)"
                        *ngIf="duel.id && controlsAvailable()" class="pt-1"><i class="fa-solid fa-chevron-left"></i></a>
                      <div [class.cell-bordered-prim_color]="duel.player_one_score < duel.player_two_score"
                        [class.cell-bordered]="duel.player_one_score >= duel.player_two_score">{{ duel.player_two_score
                        }}</div>
                      <a href="javascript:void(0)" (click)="incrementDuelScore(duel, 2)"
                        *ngIf="duel.id && controlsAvailable()" class="pt-1"><i
                          class="fa-solid fa-chevron-right"></i></a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="!duelSeries.previewDuels && controlsAvailable()">
                <!--          <tr>-->
                <!--            <td colspan="3" scope="col" class="text-center scoreTunerHider">-->
                <!--              <button type="button" class="btn btn-primary btn-sm" (click)="addDuel()">Добавить партию</button>-->
                <!--            </td>-->
                <!--          </tr>-->
              </tbody>
            </table>
          </div>
          <div class="addPartySection" *ngIf="controlsAvailable()">
            <button type="button" class="btn btn-primary btn-sm" (click)="addDuel()">Добавить партию</button>
          </div>
          <div class="row rowWithScores" *ngIf="showDuelScore()">
            <div class="col div-cenered">
              <h1 *ngIf="!controlsAvailable() || (showDuelScore() && !getIsPC())">{{ getPlayerOneScore() }}</h1>
              <button type="button" class="btn btn-sm scoreTunerHider" (click)="decrementDuelSeriesScore(1)"
                *ngIf="controlsAvailable()"><i class="fa-solid fa-chevron-left"></i></button>
              <input *ngIf="controlsAvailable()" style="min-width: 40px; text-align: center" type="text"
                name="player-one-score" id="player-one-score" [formControl]="playerOneScore" class="form-control" />
              <button type="button" class="btn btn-sm scoreTunerHider" (click)="incrementDuelSeriesScore(1)"
                *ngIf="controlsAvailable()"><i class="fa-solid fa-chevron-right"></i></button>
            </div>
            <!--        <div class="col d-none d-lg-flex"></div>-->
            <div class="col div-cenered">
              <h1 *ngIf="!controlsAvailable() || (showDuelScore() && !getIsPC())">{{ getPlayerTwoScore() }}</h1>
              <button type="button" class="btn btn-sm scoreTunerHider" (click)="decrementDuelSeriesScore(2)"
                *ngIf="controlsAvailable()"><i class="fa-solid fa-chevron-left"></i></button>
              <input *ngIf="controlsAvailable()" style="min-width: 40px; text-align: center" type="text"
                name="player-two-score" id="player-two-score" [formControl]="playerTwoScore" class="form-control" />
              <button type="button" class="btn btn-sm scoreTunerHider" (click)="incrementDuelSeriesScore(2)"
                *ngIf="controlsAvailable()"><i class="fa-solid fa-chevron-right"></i></button>
            </div>
          </div>
          <div *ngIf="duelSeries.status == 'finished'">
            <div class="row">
              <div class="col div-cenered botton-main fs10w600"
                [class.botton-main]="getPlayerOneScore() > getPlayerTwoScore()"
                [class.botton-sec]="getPlayerOneScore() < getPlayerTwoScore()"
                *ngIf="getPlayerOneScore() != getPlayerTwoScore()">
                {{ getPlayerOneScore() > getPlayerTwoScore() ? "Победа" : "Проигрыш" }}
              </div>
              <div class="col"></div>
              <div class="col div-cenered botton-main fs10w600"
                [class.botton-main]="getPlayerOneScore() < getPlayerTwoScore()"
                [class.botton-sec]="getPlayerOneScore() > getPlayerTwoScore()"
                *ngIf="getPlayerOneScore() != getPlayerTwoScore()">
                {{ getPlayerOneScore() < getPlayerTwoScore() ? "Победа" : "Проигрыш" }} </div>
              </div>
              <div class="row" *ngIf="showDuelScore()">
                <div class="col div-cenered margin10">
                  <img src="/static/img/arrow-down.svg" *ngIf="getPlayerOneNext()" />
                </div>
                <div class="col"></div>
                <div class="col div-cenered margin10">
                  <img src="/static/img/arrow-down.svg" *ngIf="getPlayerTwoNext()" />
                </div>
              </div>
              <div class="row" *ngIf="showDuelScore()">
                <div class="col div-cenered">
                  <a href="javascript:void(0)" class="fs12 fc-main" *ngIf="getPlayerOneNext()"
                    (click)="goto(getPlayerOneNext())">Встреча #{{ getPlayerOneNext() }}</a>
                </div>
                <div class="col"></div>
                <div class="col div-cenered">
                  <a href="javascript:void(0)" class="fs12 fc-main" *ngIf="getPlayerTwoNext()"
                    (click)="goto(getPlayerTwoNext())">Встреча #{{ getPlayerTwoNext() }}</a>
                </div>
              </div>
            </div>
            <div class="row mt-5 scoreTunerHider" *ngIf="controlsAvailable()">
              <div class="col-12 text-center align-self-center">
                <input type="text" name="result" id="result" [formControl]="duelsInput" class="form-control"
                  placeholder="Пример: 8-3 5-2" />
              </div>
              <div class="col-12 text-center mt-2" *ngIf="duelSeries.previewDuels">
                <button class="btn btn-primary btn-sm" (click)="save()">Сохранить</button>
                <br />
                <span class="text-muted fs12">Все партии обновятся, счет перерасчитается</span>
              </div>
            </div>
          </div>


          <div class="col-6 col-lg-4 order-2">
            <div class="d-flex div-cenered playerSectionWrapper">
              <app-player-card-small [player]="duelSeries.player_two" class="playerInnerWrapper"
                [openDuelPlayerDetails]="playerNameLinkClickHandler.bind(this)"></app-player-card-small>
              <app-player-replacer *ngIf="
            !duelSeries.group && is_staff && getIsPC()
             && duelSeries?.player_one
             && duelSeries?.player_two
             && duelCanBeReplayed()" [currentDuelId]="duelSeries?.number"
                [currentPlayerId]="duelSeries?.player_two?.id">
              </app-player-replacer>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="is_staff && getIsPC()" class="p-4">
        <div *ngIf="getIsPC() && duelCanBeReplayed()">
          <b>Администрирование встречи</b>
          <table class="table hiderOfAdminScoreButtonsMobile"
            *ngIf="(duelSeries.previewDuels && duelSeries.previewDuels.length) || (duelSeries.duels && duelSeries.duels.length > 0) || is_staff">
            <thead>
              <tr>
                <th colspan="3" class="align-center" scope="col">Результаты партий</th>
              </tr>
            </thead>
            <!--#TODO: Необходим отдельный новый компонент под административную панель, который будет доступен только по щелчку мыши-->
            <tbody *ngIf="!duelSeries.previewDuels && controlsAvailable()">
              <tr>
                <td colspan="3" scope="col" class="text-center">
                  <button type="button" class="btn btn-primary btn-sm" (click)="addDuel()">Добавить партию</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col div-cenered">
              <button type="button" class="btn btn-sm hiderOfAdminScoreButtonsMobile"
                (click)="decrementDuelSeriesScore(1)" *ngIf="controlsAvailable()"><i
                  class="fa-solid fa-chevron-left"></i></button>
              <input *ngIf="controlsAvailable()" style="min-width: 40px; text-align: center" type="text"
                name="player-one-score-mobile" id="player-one-score-mobile" [formControl]="playerOneScore"
                class="form-control" />
              <button type="button" class="btn btn-sm hiderOfAdminScoreButtonsMobile"
                (click)="incrementDuelSeriesScore(1)" *ngIf="controlsAvailable()"><i
                  class="fa-solid fa-chevron-right"></i></button>
            </div>
            <div class="col d-none d-lg-flex"></div>
            <div class="col div-cenered">
              <button type="button" class="btn btn-sm hiderOfAdminScoreButtonsMobile"
                (click)="decrementDuelSeriesScore(2)" *ngIf="controlsAvailable()"><i
                  class="fa-solid fa-chevron-left"></i></button>
              <input *ngIf="controlsAvailable()" style="min-width: 40px; text-align: center" type="text"
                name="player-two-score-mobile" id="player-two-score-mobile" [formControl]="playerTwoScore"
                class="form-control" />
              <button type="button" class="btn btn-sm hiderOfAdminScoreButtonsMobile"
                (click)="incrementDuelSeriesScore(2)" *ngIf="controlsAvailable()"><i
                  class="fa-solid fa-chevron-right"></i></button>
            </div>
          </div>
          <div class="row mt-5 hiderOfAdminScoreButtonsMobile" *ngIf="controlsAvailable()">
            <div class="col-12 text-center align-self-center">
              <input type="text" name="result" id="result-mobile" [formControl]="duelsInput" class="form-control"
                placeholder="Пример: 8-3 5-2" />
            </div>
            <div class="col-12 text-center mt-2" *ngIf="duelSeries.previewDuels">
              <button class="btn btn-primary btn-sm" (click)="save()">Сохранить</button>
              <br />
              <span class="text-muted fs12">Все партии обновятся, счет будет пересчитан</span>
            </div>
          </div>
          <div class="row pb-2" *ngIf="hideAdminPanelForEmptyPlayer()">
            <div class="col">
              <i class="fa-solid fa-play"></i>
              Статус встречи: {{ getStatus() }}

              <button class="btn btn-sm btn-primary " (click)="start()" *ngIf="duelSeries.status == 'scheduled'">Начать
                игру</button>
              <button class="btn btn-sm btn-primary " (click)="pause()"
                *ngIf="duelSeries.status == 'in_progress'">Пауза</button>

              <button class="btn btn-sm btn-primary " (click)="pause()"
                *ngIf="duelSeries.status == 'finished' && duelCanBeReplayed()">Открыть встречу</button>

              <button class="btn btn-sm btn-primary " (click)="stop()"
                *ngIf="duelSeries.status == 'in_progress'">Завершить встречу</button>
            </div>
          </div>

          <div class="row pb-2" *ngIf="tables && view != 'tablet'">
            <div class="col">
              <label for="table-select">Cтол: <b>{{ duelSeries.table?.number }}</b></label>
              <a href="/tournament/{{ duelSeries.tournament_id }}/table/{{ duelSeries.table.id }}/judge"
                *ngIf="duelSeries.table" target="_blank" class="ms-2 me-2 text-primary" title="Судейский планшет">
                <i class="fa-solid fa-tablet-screen-button"></i>
              </a>
              <a href="{{ duelSeries.table.youtube_link }}" *ngIf="duelSeries.table && duelSeries.table.youtube_link"
                target="_blank" class="text-danger" title="Плашка для трансляции"><i class="fa-solid fa-video"></i></a>
              <select class="form-control" (change)="assignTable($event)" id="table-select" style="outline: none">
                <option>{{ duelSeries.table ? "Изменить стол" : "Выберите стол" }}</option>
                <option *ngIf="duelSeries.table" [value]=""></option>
                <option *ngFor="let table of tables" [selected]="duelSeries.table_number == table.number"
                  [value]="table.number">Стол #{{ table.number }}</option>
              </select>
            </div>
          </div>

          <div class="row pb-2" *ngIf="duelSeries.status == 'scheduled'">
            <div class="col">Планируемые дата и время встречи:</div>
          </div>

          <div class="row pb-2" *ngIf="tables && view != 'tablet' && duelSeries.status == 'scheduled'">
            <div class="col-auto">
              <input type="text" name="scheduled_at_date" ngbDatepicker #d="ngbDatepicker" id="scheduled_at_date"
                [(ngModel)]="scheduledAtDate" [ngModelOptions]="{ standalone: true }" (click)="d.toggle()" />
            </div>
            <div class="col-auto">
              <ngb-timepicker [(ngModel)]="scheduledAtTime" [spinners]="false" [ngModelOptions]="{ standalone: true }"
                [size]="'small'">
              </ngb-timepicker>
            </div>
            <div class="col">
              <button class="btn btn-sm btn-primary" (click)="saveScheduledTime()">Сохранить время</button>
            </div>
          </div>

          <div class="row pb-2">
            <div class="col">До побед:</div>
          </div>

          <div class="row pb-2" *ngIf="tables && view != 'tablet'">
            <div class="col-auto">
              <input style="min-width: 50px" type="text" name="wins_count" id="wins_count" [formControl]="winsCount"
                class="form-control" />
            </div>
          </div>

          <div class="row pb-2">
            <div class="col">Ссылка на YouTube:</div>
          </div>

          <div class="row pb-2" *ngIf="view != 'tablet'">
            <div class="col">
              <input type="text" name="youtube_link" id="youtube_link" [formControl]="youtubeLink"
                class="form-control" />
            </div>
          </div>

          <div class="row pb-2">
            <div class="col">
              <a href="/tournament/{{ duelSeries.tournament_id }}/duel_series/{{ id }}/print" target="_blank"><i
                  class="fa-solid fa-print"></i> Печать протокола</a>
            </div>
          </div>
        </div>
        <!--      <button-->
        <!--        class="duelAdministrateButton"-->
        <!--        (click)="displayAdminPanel()"-->
        <!--        *ngIf="hideAdminPanelForEmptyPlayer()"-->
        <!--      >-->
        <!--        <div-->
        <!--          class="duelAdministrateButtonText"-->
        <!--        >-->
        <!--          {{getAdminButtonText()}}-->
        <!--        </div>-->
        <!--      </button>-->
      </div>
    </div>
    <button class="duelAdministrateButton" (click)="displayAdminPanel()"
      *ngIf="is_staff && duelCanBeReplayed() && !getDuelPlayerDetailsOpened()">
      <div class="duelAdministrateButtonText">
        {{getAdminButtonText()}}
      </div>
    </button>
    <app-duel-player-details tournamentId="{{duelSeries.tournament_id}}" playerId="{{getPlayerIdToShow()}}"
      playerPhoto="{{getPlayerPhoto()}}" currentDuelNumber="{{duelSeries.number}}"
      [activeModalClose]="onClickModalShutter.bind(this)" [backToDuelModal]="setDuelPlayerDetailsOpened.bind(this)"
      *ngIf="getDuelPlayerDetailsOpened()"></app-duel-player-details>

    <app-duel-admin-mobile *ngIf="adminPanelIsAvailable()"></app-duel-admin-mobile>

    <app-duel-mobile-results *ngIf="!getIsPC() && !adminPanelIsAvailable() && !getDuelPlayerDetailsOpened()">
    </app-duel-mobile-results>

  </div>